import { atom } from 'jotai'

// TODO 将来的には状態の変更も一元管理する必要あり
export const sidebarCollapseAtom = atom(false)